<div class="button-wrapper">
  <button class="button create-comment-button" (click)="isModalOpen.set(true)">
    <fa-icon [icon]="faComment" class="create-comment-icon"></fa-icon>
    Avisos
  </button>
</div>

@if (isModalOpen()) {
  <div class="modal is-active">
    <div class="modal-background" (click)="closeModal()"></div>
    <div class="modal-card">
      <button class="modal-close-button" (click)="closeModal()" type="button">
        <fa-icon [icon]="faXmark"></fa-icon>
      </button>
      <section class="modal-card-body">
        <h3 class="modal-title">Avisos de modelos</h3>

        <!-- Selectores -->
        <div class="selectors-section">
          <div class="field">
            <label class="label">Cliente</label>
            <p-dropdown
              [options]="clients()"
              [(ngModel)]="selectedClient"
              optionLabel="name"
              optionValue="id"
              [filter]="true"
              filterBy="name"
              [showClear]="true"
              placeholder="Seleccionar cliente"
              (onChange)="onClientSelected($event)"
              [emptyFilterMessage]="'No se encontraron resultados'"
              [disabled]="isLoading()"
            ></p-dropdown>
          </div>
          <div class="field">
            <label class="label">Modelo</label>
            <p-dropdown
              [options]="contracts()"
              [(ngModel)]="selectedContract"
              optionLabel="model.name"
              optionValue="id"
              [filter]="true"
              filterBy="model.name"
              [showClear]="true"
              placeholder="Seleccionar modelo"
              (onChange)="onContractSelected($event)"
              [emptyFilterMessage]="'No se encontraron resultados'"
              [disabled]="!selectedClient() || isLoading()"
            ></p-dropdown>
          </div>
        </div>

        <!-- Lista de avisos existentes -->
        <div class="observations-list">
          @if (selectedContract()) {
            @if (contractObservations().length > 0) {
              @for (obs of contractObservations(); track obs.id) {
                <div class="observation-item">
                  <div class="observation-header">
                    <div class="observation-info">
                      <strong>{{ obs.user?.name }}</strong>
                      <span class="observation-date">{{ obs.created_at | utcDate }}</span>
                    </div>
                    @if (canDeleteAviso(obs)) {
                      <button
                        class="delete-observation-btn"
                        (click)="deleteAviso(obs)"
                        title="Eliminar aviso"
                        type="button"
                      >
                        <fa-icon [icon]="faTrash"></fa-icon>
                      </button>
                    }
                  </div>
                  <p class="observation-comment">{{ obs.comment }}</p>
                </div>
              }
            } @else {
              <p class="no-observations">No hay avisos para este modelo</p>
            }
          } @else {
            <p class="no-observations">Selecciona un modelo para ver sus avisos</p>
          }
        </div>

        <!-- Log de avisos eliminados -->
        @if (selectedContract()) {
          <div class="deleted-log-section">
            <button
              class="toggle-deleted-btn"
              type="button"
              (click)="toggleDeletedAvisos()"
              [disabled]="isLoading()"
            >
              <fa-icon [icon]="showDeletedAvisos() ? faChevronUp : faChevronDown"></fa-icon>
              {{ showDeletedAvisos() ? "Ocultar avisos eliminados" : "Ver avisos eliminados" }}
            </button>

            @if (showDeletedAvisos()) {
              <div class="observations-list deleted-list">
                @if (deletedAvisos().length > 0) {
                  @for (obs of deletedAvisos(); track obs.id) {
                    <div class="observation-item is-deleted">
                      <div class="observation-header">
                        <div class="observation-info">
                          <strong>{{ obs.user?.name }}</strong>
                          <span class="observation-date">{{ obs.created_at | utcDate }}</span>
                          <span class="tag is-danger">Eliminado el {{ obs.deleted_at | utcDate }}</span>
                        </div>
                      </div>
                      <p class="observation-comment">{{ obs.comment }}</p>
                    </div>
                  }
                } @else {
                  <p class="no-observations">No hay avisos eliminados</p>
                }
              </div>
            }
          </div>
        }

        <!-- Nuevo aviso -->
        <div class="add-observation-section">
          <div class="field">
            <label class="label">Nuevo aviso</label>
            <textarea
              class="textarea"
              [(ngModel)]="comment"
              placeholder="Escribe aquí tu aviso..."
              rows="3"
              [disabled]="!selectedContract()"
              maxlength="500"
            ></textarea>
          </div>
          <div class="buttons-container-right">
            <button
              class="button cancel-button"
              type="button"
              (click)="closeModal()"
            >
              Cerrar
            </button>
            <button
              class="button save-button"
              [disabled]="!comment() || isLoading() || !selectedContract()"
              (click)="addComment()"
            >
              Añadir aviso
            </button>
          </div>
        </div>
      </section>
    </div>
  </div>
}
